import React from 'react'
import { navigate } from 'gatsby'
import { useLocation } from '@reach/router'
import { useSwaggerLimitedRelease, useSwaggerMetadata } from '../../../hooks'
// import { DownloadSchemaButton } from '../DownloadSchemaButton/DownloadSchemaButton'
import * as apiUtils from '../../../lib/api-utils'
import { useApplicationContext } from '../../../provider'
import { isEmpty } from 'lodash'

/**
 * 
 * TODO: 
 * When the get schema button it's ready to be add it: 
 * 1. Please uncomment the import above.
 * 2. Add this component just how the props are defined, make sure
 * that it's below the <div> with the class = "dax-preamble".
 * 
 * Component to add:
 * 
 * <DownloadSchemaButton
        fileObject={downloadSchemaFile}
        fileTitle={`${downloadSchemaTitle}`}
    />
 *
 *  3. Remove this TODO.
 * 
 */

export default function Header({
  versions,
  title,
  description,
  location,
  currentVersion,
}) {
  const _pathname = useLocation()
  const { nodes } = useSwaggerMetadata()
  const { nodes: nodesLimitedRelease } = useSwaggerLimitedRelease()
  const { user } = useApplicationContext()
  const userLoggedOut = !user?.loggedIn

  const swaggerFile = nodes
    .filter((ctx) => ctx.info.title === title)
    .filter((file) => {
      if (file.version) {
        return _pathname.pathname.includes(file.version)
      }
      return file
    })
    .map((node) => node)

  const swaggerFileLimitedRelease = nodesLimitedRelease
    .filter((ctx) => ctx.info.title === title)
    .filter((file) => {
      if (file.version) {
        return _pathname.pathname.includes(file.version)
      }
      return file
    })
    .map((node) => node)

  const downloadSchemaTitle = title.toLowerCase().replace(/ /g, '-')

  const downloadSchemaFile =
    typeof window !== 'undefined' &&
    window.location.pathname.includes('limited-release')
      ? swaggerFileLimitedRelease
      : swaggerFile

  let versionSection = null
  let versionSectionText = null
  const changeVersion = ({ target: { value: newVersion } }) => {
    let newPath
    let tokens = location.pathname.endsWith('/')
      ? location.pathname.slice(0, -1).split('/')
      : location.pathname.split('/')
    /* Removes current version from path if external api & `api` from path if limited-release api */
    tokens.pop()
    newPath = `${tokens.join('/')}/${newVersion}`
    navigate(`${newPath}/`)
  }

  if (versions) {
    versionSection = versions.map((obj, key) => {
      return (
        <option
          value={obj.version}
          key={key}
          selected={currentVersion === obj.version}
        >
          {obj.version}
        </option>
      )
    })
    versionSectionText = (
      <div className="vx_floatingLabel version-select">
        <label htmlFor="floating-select">API Version</label>
        <div className="vx_select" data-label-content="API Version">
          <select
            id="floating-select"
            className="form-control vx_form-control"
            onChange={changeVersion}
          >
            {versionSection}
          </select>
        </div>
        <span className="vx_selectIcon_error" />
      </div>
    )
  }
  /*let majorVersionText = null;
    if (majorVersion) {
        majorVersionText = <small>{majorVersion}</small>
    }*/
  let parsedAPIDescription = ``
  if (description) {
    parsedAPIDescription = apiUtils.parseMarkdown(description)
  }

  return (
    <header className={!userLoggedOut ? 'dax-topic dax-loggedIn' : 'dax-topic'}>
      <div className="versionSelectWrapper">
        <h1 className="dx-content-title">{title} API</h1>
        {versionSectionText}
      </div>
      <div
        className="dax-preamble"
        dangerouslySetInnerHTML={{ __html: parsedAPIDescription }}
      />
    </header>
  )
}
